/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-statements */
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { FaExchangeAlt } from 'react-icons/fa';
import { QueryClient, useMutation, useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { globalEnv } from '../../../config/baseConfig';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import { SetNotificationAction } from '../../../redux/actions/notificationAction';
import { hideSearchbarAction } from '../../../redux/actions/searchBarAction';
import {
	setSelectedSection,
	setTab
} from '../../../redux/actions/sideBarAction';
import Pagination from '../../Tables/pagination';
import LazyImage from '../../Tables/TablesList/Components/imageComponent';
import Editable from '../../Utils/editable';
import { DataNotFoundAnimation } from '../../Utils/ErrorAnimations/dataNotFoundAnim';
import LoadingAnimComponent from '../../Utils/LoadingAnimations/loadingAnimation';
import { stateNotificationsEnum } from '../../Utils/notification';
import SaveButton from '../../Utils/saveButton';
import { AddMediaModalContent } from './imageComponents/addMultipleImagesModalContent';
import ParentModal from '../../Utils/Components/parentModal';
import UpdateCreator, { ContribModal } from './changeCreator';
import { UserListModalContent } from './userListModal';
import AddContributors from './addContributors';
import { AiOutlineUserAdd } from 'react-icons/ai';
import { Switch } from '@headlessui/react';
import { Tag } from '../../Utils/Components/tag';
import LoadingRectanglesAnimation from '../../Utils/LoadingAnimations/LoadingRectanglesAnimation';
import { BackgroundImage } from './imageComponents/imageComponent';
import StyleModalContent from './TopicStyling/styleModal';
import RemoveModal from '../../Utils/Components/removeModal';
import { ClockTypes } from './TopicStyling/StyleComponents/mixins/optionsValues';
import {
	BasicTopicStyle,
	TopicStyles
} from './TopicStyling/StyleComponents/mixins/mixins';
import { VideoComponent } from './imageComponents/VideoComponent';

export enum MediaType {
	IMAGES = 'images',
	PHONE_IMAGES = 'phoneImages',
	VIDEOS = 'videos',
	PHONE_VIDEOS = 'phoneVideos'
}

const queryClient = new QueryClient();
export default function Topic() {
	const [topicId, setId] = useState('');
	const [name, setName] = useState('');
	const [code, setCode] = useState('');
	const [creator, setCreator] = useState<any>();
	const [coverPic, setCoverPic] = useState<string>('');
	const [referralCode, setReferralCode] = useState<string>('');
	const [dailyImage, setDailyImage] = useState('');
	const [dailyImageId, setDailyImageId] = useState('');
	const [description, setDescription] = useState('');
	const [usersCount, setUsersCount] = useState(0);
	const [activeUsersCount, setActiveUsersCount] = useState(0);
	const [reloadCount, setReloadCount] = useState(0);

	const [createDate, setCreateDate] = useState(null);

	const nameRef = useRef<null>(null);
	const descriptionRef = useRef<null>(null);
	const codeRef = useRef<null>(null);

	const [page, setPage] = useState(1);

	const [media, setMedia] = useState<any[]>([]);
	const [mediaCount, setMediaCount] = useState(0);
	const [extensionMedia, setExtensionMedia] = useState<string[]>([]);

	// const [isShowingPhoneImgs, setIsShowingPhoneImgs] = useState(false);

	const [mediaType, setMediaType] = useState(MediaType.IMAGES);

	const [isAddMultipleImagesModalOpen, setAddMultipleImagesModalOpen] =
		useState(false);
	const [isAddMultipleImagesModalChanged, setAddMultipleImagesModalChanged] =
		useState(false);

	const [isUsersModalOpen, setIsUsersModalOpen] = useState(false);
	const [isActiveUsersModalOpen, setIsActiveUsersModalOpen] = useState(false);
	const [isFirstTime, setIsFirstTime] = useState(true);

	const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);
	const [isChanged, setIsChanged] = useState(false);

	const [reviewStatus, setReviewStatus] = useState('pending');
	const [featuredStatus, setFeaturedStatus] = useState('none');

	const [isPrivate, setIsPrivate] = useState(false);
	const [style, setStyle] = useState<TopicStyles>(BasicTopicStyle);
	const [isStyleModalOpen, setIsStyleModalOpen] = useState(false);

	const [isSearchingCreator, setIsSearchingCreator] = useState(false);
	const [isCreatorModalChanged, setIsCreatorModalChanged] = useState(false);

	const [contributors, setContributors] = useState<any>([
		{
			_id: '0',
			username: 'Meavana'
		}
	]);

	const [isSearchingConributors, setIsSearchingConributors] = useState(false);
	const [isContribModalChanged, setIsContribModalChanged] = useState(false);
	const [tags, setTags] = useState<string[]>([]);

	const [isSaving, setIsSaving] = useState(false);
	const { id } = useParams();

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});

	const dispatch = useDispatch();
	dispatch(setSelectedSection('Topic Details'));
	dispatch(setTab('documents'));
	dispatch(hideSearchbarAction());

	const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const { data, isFetching, isLoading, isError } = useQuery(
		['topics', topicId, page, mediaType, reloadCount],
		() => fetchTopicDetails(id!, page, ACCESS_TOKEN),
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: 5000,
			cacheTime: 5000
		}
	);

	async function fetchTopicDetails(
		id: string,
		page: number,
		accessToken: string
	) {
		const config = {
			headers: {
				Authorization: 'Bearer ' + accessToken
			}
		};

		const { data } = await axios.get(
			`${globalEnv.BASE_URL}/admin/topic/${id}/get-detailed?page=${page}&mediaType=${mediaType}`,
			config
		);
		return data;
	}

	// Prefetch the next page!
	useEffect(() => {
		if (data == null) return;
		if (page < data.meta.limit) {
			queryClient.prefetchQuery(['topics', page + 1], () =>
				fetchTopicDetails(id!, page + 1, ACCESS_TOKEN)
			);
		}
	}, [data, page, mediaType, queryClient]);

	const navigate = useNavigate();

	useEffect(() => {
		if (data != null) {
			if (isFirstTime) {
				setName(data.data[0].name);
				if (data.data[0].description != null)
					setDescription(data.data[0].description);
				setCode(data.data[0].code);

				if (data.data[0].reviewStatus != null)
					setReviewStatus(data.data[0].reviewStatus);
				else setReviewStatus('pending');
				if (data.data[0].featuredStatus != null)
					setFeaturedStatus(data.data[0].featuredStatus);
				else setFeaturedStatus('none');
				if (data.data[0].isPrivate != null)
					setIsPrivate(data.data[0].isPrivate);
				else setIsPrivate(true);

				if (data.data[0].creator != null) setCreator(data.data[0].creator[0]);
				else setCreator(null);
				if (data.data[0].tags != null) setTags(data.data[0].tags);

				if (data.data[0].newStyle != null) {
					let clock;
					try {
						if (data.data[0].newStyle.clock.kind === ClockTypes.Analog)
							clock = {
								kind: data.data[0].newStyle.clock.kind,
								showSeconds: data.data[0].newStyle.clock.showSeconds,
								size: data.data[0].newStyle.clock.size,
								isDark: data.data[0].newStyle.clock.isDark,
								isNumbered: data.data[0].newStyle.clock.isNumbered
							};
						else if (data.data[0].newStyle.clock.kind === ClockTypes.Digital)
							clock = {
								kind: data.data[0].newStyle.clock.kind,
								showSeconds: data.data[0].newStyle.clock.showSeconds,
								size: data.data[0].newStyle.clock.size,
								boldness: data.data[0].newStyle.clock.boldness,
								showAmPm: data.data[0].newStyle.clock.showAmPm,
								showTwentyFour: data.data[0].newStyle.clock.showTwentyFour
							};
						else
							clock = {
								kind: data.data[0].newStyle.clock.kind,
								size: data.data[0].newStyle.clock.size,
								boldness: data.data[0].newStyle.clock.boldness
							};
					} catch (e) {
						clock = BasicTopicStyle.clock;
					}

					try {
						let defaultBookmarkList;
						if (data.data[0].defaultBookmarkList != null)
							defaultBookmarkList = data.data[0].defaultBookmarkList;
						else defaultBookmarkList = BasicTopicStyle.defaultBookmarkList;

						setStyle({
							appearanceStyle: {
								font: data.data[0].newStyle.appearanceStyle.font,
								mode: data.data[0].newStyle.appearanceStyle.mode,
								opacity: data.data[0].newStyle.appearanceStyle.opacity,
								view: data.data[0].newStyle.appearanceStyle.view
							},
							quoteStyle: {
								size: data.data[0].newStyle.quoteStyle.size,
								useCustomQuote: data.data[0].newStyle.quoteStyle.useCustomQuote,
								customQuote:
									data.data[0].newStyle.quoteStyle.customQuote != null
										? data.data[0].newStyle.quoteStyle.customQuote
										: null
							},
							sidebarStyle: {
								contentWidth: data.data[0].newStyle.sidebarStyle.contentWidth,
								width: data.data[0].newStyle.sidebarStyle.width,
								view: data.data[0].newStyle.sidebarStyle.view
							},
							wallpaperStyle: {
								background: data.data[0].newStyle.wallpaperStyle.background,
								blur: data.data[0].newStyle.wallpaperStyle.blur,
								brightness: data.data[0].newStyle.wallpaperStyle.brightness
							},
							searchbarOptions: data.data[0].newStyle.searchbarOptions,
							searchEngines: data.data[0].newStyle.searchEngines,
							focusStyle:
								data.data[0].newStyle.focusStyle != null
									? {
											myFocus: data.data[0].newStyle.focusStyle.myFocus,
											size: data.data[0].newStyle.focusStyle.size
									  }
									: BasicTopicStyle.focusStyle,
							greetingStyle:
								data.data[0].newStyle.greetingStyle != null
									? { size: data.data[0].newStyle.greetingStyle.size }
									: BasicTopicStyle.greetingStyle,
							clock: clock,
							featuresStyle: {
								time: data.data[0].newStyle.featuresStyle.time,
								date: data.data[0].newStyle.featuresStyle.date,
								weather: data.data[0].newStyle.featuresStyle.weather,
								bookmarks: data.data[0].newStyle.featuresStyle.bookmarks,
								notes: data.data[0].newStyle.featuresStyle.notes,
								quote: data.data[0].newStyle.featuresStyle.quote,
								integrations: data.data[0].newStyle.featuresStyle.integrations,
								searchBar: data.data[0].newStyle.featuresStyle.searchBar
							},
							integrationsStyle: data.data[0].newStyle.integrationsStyle,
							bookmarkStyle: {
								selectedBookmarks:
									data.data[0].newStyle.bookmarkStyle.selectedBookmarks,
								blackAndWhite:
									data.data[0].newStyle.bookmarkStyle.blackAndWhite,
								openNewTab: data.data[0].newStyle.bookmarkStyle.openNewTab,
								square: data.data[0].newStyle.bookmarkStyle.square,
								gap: data.data[0].newStyle.bookmarkStyle.gap,
								size: data.data[0].newStyle.bookmarkStyle.size
							},
							defaultBookmarkList: defaultBookmarkList
						});
					} catch (e) {
						console.log(e);
					}
				}

				setIsFirstTime(false);
			}
			if (data.data[0].coverPic) setCoverPic(data.data[0].coverPic.url);
			setId(data.data[0]._id);
			setCreateDate(data.data[0].createdAt);
			setUsersCount(data.data[0].usersCount);
			if (data.data[0].extensionImages != null) {
				const extensionImagesData = data.data[0].extensionImages.map(
					(item: any) => item._id
				);
				setExtensionMedia(extensionImagesData);
			} else setExtensionMedia([]);
			setContributors(data.data[0].contributors);
			setActiveUsersCount(data.data[0].activeUsersCount);
			setMediaCount(data.meta.total);
			if (data.data[0].dailyImage != null) {
				setDailyImage(data.data[0].dailyImage.url);
				setDailyImageId(data.data[0].dailyImage._id);
			}
			setMedia(data.data[0].media);
		}
	}, [data]);

	const CreationDate = () => {
		return (
			<div className="">
				<div className=" mb-2 text-gray-700 mt-0.5">
					<h3 className="text-sm font-bold dark:text-gray-100 text-oldgray-600 transition-colors duration-500">
						{'Creation Date: '}
					</h3>
					<h3 className="text-green-600 text-sm font-bold">
						{moment(createDate).format('MM/DD/YYYY - HH:mm')}
					</h3>
				</div>
			</div>
		);
	};

	const GeneralData = () => {
		return (
			<div className="flex justify-center md:py-4 lg:pt-3">
				<div
					className="md:p-2 p-2 md:px-0 text-center ml-8 mr-2 cursor-pointer"
					onClick={() => setIsUsersModalOpen(true)}
				>
					<span className="text-xl font-bold block uppercase tracking-wide text-gray-600 dark:text-white transition-all duration-500">
						{usersCount}
					</span>
					<span className="text-sm text-gray-600 dark:text-gray-400 font-semibold transition-all duration-500">
						Subscribed Users
					</span>
				</div>
				<ParentModal
					visible={isUsersModalOpen}
					setModalOpen={setIsUsersModalOpen}
					isChanged={false}
					setIsChanged={() => {
						return;
					}}
					isWarnModalOpen={isWarnModalOpen}
					setIsWarnModalOpen={setIsWarnModalOpen}
				>
					<UserListModalContent isActiveUsers={false} topicId={topicId} />
				</ParentModal>

				<ParentModal
					visible={isActiveUsersModalOpen}
					setModalOpen={setIsActiveUsersModalOpen}
					isChanged={false}
					setIsChanged={() => {
						return;
					}}
					isWarnModalOpen={isWarnModalOpen}
					setIsWarnModalOpen={setIsWarnModalOpen}
				>
					<UserListModalContent isActiveUsers={true} topicId={topicId} />
				</ParentModal>

				<div
					className="md:p-2 px-2 md:px-0 text-center"
					onClick={() => setIsActiveUsersModalOpen(true)}
				>
					<span className="text-xl font-bold block uppercase tracking-wide text-gray-600 dark:text-white transition-all duration-500">
						{activeUsersCount}
					</span>
					<span className="text-sm text-gray-600 dark:text-gray-400 font-semibold transition-all duration-500">
						Active users
					</span>
				</div>
				<div className="md:p-2 text-center">
					<span className="text-xl font-bold block uppercase tracking-wide text-gray-600 dark:text-white transition-all duration-500">
						{mediaCount}
					</span>
					<span className="text-sm text-gray-600 dark:text-gray-400 font-semibold transition-all duration-500">
						Items count
					</span>
				</div>
			</div>
		);
	};

	const saveTopicReq = async () => {
		if (isPrivate == null) setIsPrivate(true);

		// Topic could be without a creator, that's why a check is needed
		let creatorId = null;
		if (creator != null) creatorId = creator._id;

		const dto = {
			topicId: topicId,
			name: name,
			description: description,
			code: code,
			creator: creatorId,
			newStyle: style,
			tags: tags,
			defaultBookmarkList: style.defaultBookmarkList,
			isPrivate: isPrivate,
			reviewStatus: reviewStatus,
			extensionImages: extensionMedia,
			featuredStatus: featuredStatus,
			contributors: contributors.map((item: any) => item._id)
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axios.put(
			globalEnv.BASE_URL + '/admin/topic/update',
			dto,
			config
		);
		return response;
	};

	const deleteTopic = () => {
		setIsRemoveModalOpen(false);
		mutate();
	};

	const deleteTopicReq = async () => {
		const { data: response } = await axios.delete(
			globalEnv.BASE_URL + '/admin/topic/delete',
			{
				data: {
					topicId: topicId
				},
				headers: {
					Authorization: 'Bearer ' + ACCESS_TOKEN
				}
			}
		);
		return response;
	};

	useEffect(() => {
		return () => {
			console.log('Unmount!');
		};
	}, []);

	const saveTopic = useMutation(saveTopicReq, {
		onMutate: () => setIsSaving(true),
		onSuccess: () => {
			setIsSaving(false);
			setIsChanged(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully updated topic info.'
				})
			);
		},
		onError: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't update topic info."
				})
			);
		}
	});

	const generateEncryptedReferralCodeReq = async () => {
		let dto: any = {
			topicCode: code
		};

		if (referralCode.length > 1) {
			dto = {
				topicCode: code,
				referralCode: referralCode
			};
		}

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axios.post(
			globalEnv.BASE_URL + `/signup-topic/encrypt-code`,
			dto,
			config
		);
		return response;
	};

	const generateEncryptedReferralCode = useMutation(
		generateEncryptedReferralCodeReq,
		{
			onMutate: () => setIsSaving(true),
			onSuccess: (data) => {
				if (referralCode.length > 1)
					navigator.clipboard.writeText(
						`https://meavana.com/?en-topic=${data.message.topicCode}&en-rc=${data.message.referralCode}`
					);
				else
					navigator.clipboard.writeText(
						`https://meavana.com/?en-topic=${data.message.topicCode}`
					);

				dispatch(
					SetNotificationAction({
						type: stateNotificationsEnum.SUCCESS,
						message: 'Topic URL copied to clipboard.'
					})
				);
			},
			onError: () => {
				setIsSaving(false);
				dispatch(
					SetNotificationAction({
						type: stateNotificationsEnum.ERROR,
						message: "Couldn't generate a referral code."
					})
				);
			}
		}
	);

	function addTag() {
		setTags([...tags, '']);
	}

	const { mutate } = useMutation(deleteTopicReq, {
		onSuccess: () => {
			navigate('../documents');
		},

		onError: (error) => {
			console.log(error);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't delete topic."
				})
			);
		}
	});

	const creatorSearchRef = useRef(null) as any;
	const contribSearchRef = useRef(null) as any;

	return (
		<div className="content-container">
			<Scrollbars autoHide>
				{isLoading ? (
					<LoadingAnimComponent />
				) : isError ? (
					<div className="h-full ">
						<div className="flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
							<div className="mx-auto my-auto self-center">
								<div className="min-h-16">
									<DataNotFoundAnimation height={dimensions.height / 1.5} />
								</div>
								<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
									{"Couldn't find the data you're looking for!"}
								</h3>
							</div>
						</div>
					</div>
				) : (
					<main>
						<section className="relative block" style={{ height: '500px' }}>
							<div
								className="absolute top-0 w-full h-full bg-center bg-cover"
								style={{
									backgroundImage: `url('${coverPic ? coverPic : dailyImage}')`
								}}
							>
								<span
									id="blackOverlay"
									className="w-full h-full absolute opacity-50 bg-black"
								></span>
							</div>
						</section>
						<section className="relative py-16 bg-gray-400 dark:bg-gray-600 transition-all duration-500">
							<div className="container mx-auto px-4">
								<div
									className="relative flex flex-col min-w-0 break-words bg-base-bg-light dark:bg-base-bg-dark
											transition-all duration-500 w-full shadow-xl rounded-lg -mt-64"
								>
									<div className="px-6">
										<div className="flex flex-col md:flex-row justify-between mx-auto bg-gray-200 dark:bg-gray-700 rounded-xl w-full lg:w-10/12 transition-all duration-500">
											<div className="md:w-2/12 mb-2 md:mb-0 md:order-1 order-2 lg:w-1/12 md:ml-6 self-center">
												<GeneralData />
											</div>

											<div className="w-full md:w-8/12 order-1 md:order-2 lg:w-10/12 md:px-6 text-center self-center">
												<Editable
													text={name}
													placeholder="Topic name"
													childRef={nameRef}
													type="input"
													className="text-6xl font-semibold leading-snug pb-1"
													textColor="dark:text-primary-text-dark text-primary-text-light transition-colors duration-500"
												>
													<input
														ref={nameRef}
														type="text"
														name="name"
														className="shadow rounded text-6xl font-semibold leading-relaxed text-primary-text-light text-center
													dark:bg-base-bg-dark transition-all duration-500 dark:text-primary-text-dark pb-1 w-11/12"
														placeholder=""
														value={name}
														onChange={(e) => {
															setName(e.target.value);
															setIsChanged(true);
														}}
													/>
												</Editable>
											</div>

											<div className="md:flex-1 order-3 md:w-2/12 lg:w-1/12 mr-6 mb-3 md:mb-0 text-center self-center">
												<CreationDate />
											</div>
										</div>

										<div className={'lg:w-7/12 ml-auto'}>
											<h3 className="font-bold mb-2 text-sm lg:text-base dark:text-gray-100">
												Tags
											</h3>
											<div className="flex flex-row space-x-2">
												{tags != null &&
													tags.map((tag, index) => (
														<Tag
															name={tag}
															isMine={true}
															setIsChanged={setIsChanged}
															index={index}
															setTags={setTags}
															tags={tags}
														/>
													))}

												{tags != null ? (
													tags.length > 0 ? (
														<div
															className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
														>
															<span
																className="text-xs font-bold mx-1"
																onClick={addTag}
															>
																➕
															</span>
														</div>
													) : (
														<div className="inline-block">
															<span className="text-xs font-bold mx-1 text-gray-400">
																This topic has no Tags
															</span>
															<div
																className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
															>
																<span
																	className="text-xs font-bold mx-1"
																	onClick={addTag}
																>
																	Create Topic's first Tag➕
																</span>
															</div>
														</div>
													)
												) : (
													<div className="inline-block">
														<span className="text-xs font-bold mx-1 text-gray-400">
															This topic has no Tags
														</span>
														<div
															className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
														>
															<span
																className="text-xs font-bold mx-1"
																onClick={addTag}
															>
																Create Topic's first Tag➕
															</span>
														</div>
													</div>
												)}
											</div>
										</div>

										<div className="text-center">
											<div className="text-gray-500 font-bold mx-auto">
												<div className="flex flex-row mx-auto">
													<div className="leading-normal mt-5 mb-2 text-gray-500 dark:text-white text-left w-28 mx-auto">
														<label
															about="Status"
															className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
														>
															Status
														</label>
														<select
															id="Status"
															className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
															focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700
															dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500
															dark:focus:border-blue-500"
															onChange={(e) => {
																setIsChanged(true);
																setReviewStatus(e.target.value);
															}}
														>
															<option
																selected={reviewStatus === 'pending'}
																value="pending"
															>
																Pending
															</option>
															<option
																selected={reviewStatus === 'additional review'}
																value="additional review"
															>
																Additional review
															</option>
															<option
																selected={reviewStatus === 'accepted'}
																value="accepted"
															>
																Accepted
															</option>
															<option
																selected={reviewStatus === 'featured'}
																value="featured"
															>
																Featured on Meavana
															</option>
															<option
																selected={reviewStatus === 'rejected'}
																value="rejected"
															>
																Rejected
															</option>
														</select>
													</div>

													<div className="leading-normal mt-5 mb-2 text-gray-500 dark:text-white text-left w-28 mx-auto">
														<label
															about="Status"
															className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
														>
															Featured Status
														</label>
														<select
															id="FeaturedStatus"
															className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
															focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700
															dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500
															dark:focus:border-blue-500"
															onChange={(e) => {
																setIsChanged(true);
																setFeaturedStatus(e.target.value);
															}}
														>
															<option
																selected={featuredStatus === 'none'}
																value="none"
															>
																None
															</option>
															<option
																selected={featuredStatus === 'hotlist'}
																value="hotlist"
															>
																Hotlist
															</option>
															<option
																selected={featuredStatus === 'fandom'}
																value="fandom"
															>
																Fandom
															</option>
														</select>
													</div>

													<div className="w-3/12 text-left mt-5 mb-2">
														<div className="flex flex-row">
															<h3 className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">
																Creator
															</h3>
															<div className="relative group w-fit max-w-300">
																<div
																	key={'add-contrib-btn'}
																	className="ml-2 cursor-pointer
																border-gray-400 bg-gray-400 text-gray-500
																dark:bg-gray-700 dark:text-white dark:border-gray-700 transition-all duration-500"
																	onClick={() => {
																		setIsSearchingCreator(!isSearchingCreator);
																	}}
																	ref={creatorSearchRef}
																>
																	<FaExchangeAlt size={14} className="mt-1" />
																</div>

																<ContribModal
																	visible={isSearchingCreator}
																	setModalOpen={setIsSearchingCreator}
																	isChanged={isCreatorModalChanged}
																	setIsChanged={setIsCreatorModalChanged}
																	isWarnModalOpen={isWarnModalOpen}
																	setIsWarnModalOpen={setIsWarnModalOpen}
																/>
																{isSearchingCreator && (
																	<div className="absolute mt-14 z-30 w-60">
																		<UpdateCreator
																			buttonRef={creatorSearchRef}
																			isModalOpen={isSearchingCreator}
																			setIsModalOpen={setIsSearchingCreator}
																			creator={creator}
																			setCreator={setCreator}
																			setIsChanged={setIsChanged}
																		/>
																	</div>
																)}
															</div>
														</div>
														{creator != null && (
															<div
																className="w-fit h-fit flex items-start p-2 rounded-xl dark:hover:bg-gray-600 hover:bg-gray-400 cursor-pointer"
																onClick={() => {
																	return;
																}}
															>
																<div className="mr-2">
																	<LazyImage
																		photo={
																			creator.photo != null
																				? creator.photo
																				: `https://api.dicebear.com/7.x/bottts/svg?seed=${creator.username}`
																		}
																		dimesnions={'25'}
																		loaderDimesnions={23}
																	/>
																</div>
																<div className="font-medium text-sm mt-0.5 text-gray-800 dark:text-white group-hover:text-white dark:group-hover:text-gray-800">
																	{creator.username}
																</div>
															</div>
														)}
													</div>

													<div className="relative w-4/12 text-left mt-5 mb-2">
														<div className="">
															<h3 className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">
																Contributors
															</h3>
															<div
																className={`flex flex-row ml-auto mt-1.5 ${
																	isSearchingConributors && 'z-30'
																}`}
																ref={contribSearchRef}
															>
																{contributors.map((contributor: any) => (
																	<div
																		className="relative group mr-1 mt-0.5 cursor-pointer"
																		onClick={(e) => {
																			if (isSearchingConributors) {
																				const contributorsCopy =
																					contributors.slice();
																				const updatedContributorsList =
																					contributorsCopy.filter(
																						(item: any) => {
																							return (
																								contributor._id !== item._id
																							);
																						}
																					);
																				setContributors(
																					updatedContributorsList
																				);
																			} else if (contributors.length > 0) {
																				e.stopPropagation();
																				navigate(`../user/${contributor._id}`);
																			}
																		}}
																	>
																		<LazyImage
																			photo={
																				contributor.photo != null
																					? contributor.photo
																					: `https://api.dicebear.com/7.x/bottts/svg?seed=${contributor.username}`
																			}
																			dimesnions={'27'}
																			loaderDimesnions={27}
																		/>

																		{isSearchingConributors ? (
																			<span
																				className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
																	scale-0 origin-top group-hover:scale-100 z-30
																	font-bold transition-all duration-500 opacity-0 group-hover:opacity-100 -top-10 -right-10"
																			>
																				{'Click to remove'}
																			</span>
																		) : (
																			<span
																				className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
															scale-0 origin-top group-hover:scale-100 z-30
															font-bold transition-all duration-500 opacity-0 group-hover:opacity-100
															top-[100%] left-[50%] translate-x-[-50%] translate-y-[-50%]"
																			>
																				{contributor.username}
																			</span>
																		)}
																	</div>
																))}
																<div className="relative group ">
																	<button
																		key={'add-contrib-btn'}
																		className="btn btn-outline rounded-full btn-sm btn-primary ml-1 z-30"
																		onClick={() => {
																			setIsSearchingConributors(
																				!isSearchingConributors
																			);
																		}}
																		ref={contribSearchRef}
																	>
																		<AiOutlineUserAdd size={20} />
																	</button>
																	{isSearchingConributors || (
																		<span
																			className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
																	scale-0 origin-top group-hover:scale-100 z-50
																	font-bold transition-all duration-500 opacity-0 group-hover:opacity-100 top-10 -right-36"
																		>
																			{
																				'Edit your contributors list to help manage your topic 🙋'
																			}
																		</span>
																	)}
																</div>
															</div>
															<ContribModal
																visible={isSearchingConributors}
																setModalOpen={setIsSearchingConributors}
																isChanged={isContribModalChanged}
																setIsChanged={setIsContribModalChanged}
																isWarnModalOpen={isWarnModalOpen}
																setIsWarnModalOpen={setIsWarnModalOpen}
															/>
															{isSearchingConributors && (
																<div className="absolute mt-5 z-30 w-60">
																	<AddContributors
																		buttonRef={contribSearchRef}
																		isModalOpen={isSearchingConributors}
																		setIsModalOpen={setIsSearchingConributors}
																		contributors={contributors}
																		setContributors={setContributors}
																		setIsChanged={setIsChanged}
																	/>
																</div>
															)}
														</div>
													</div>
												</div>

												<div className="mt-4 mb-2 text-gray-500 text-left w-10/12 mx-auto flex flex-row">
													<i className="fas fa-map-marker-alt mr-2 text-sm text-gray-600" />
													<h3 className="leading-normal font-semibold text-lg lg:text-xl dark:text-white text-gray-600">
														{'Code: '}
													</h3>
													<Editable
														text={code}
														placeholder="No code is provided"
														childRef={codeRef}
														type="input"
														className="font-bold text-lg lg:text-xl leading-normal px-2"
														textColor="text-gray-700 dark:text-gray-200"
													>
														<input
															ref={codeRef}
															type="text"
															name="name"
															className="shadow rounded font-bold leading-normal text-gray-700 px-2
														 		dark:bg-gray-800 dark:text-gray-200 text-lg lg:text-xl"
															placeholder="Topic1230"
															value={code}
															onChange={(e) => {
																setCode(e.target.value);
																setIsChanged(true);
															}}
														/>
													</Editable>
												</div>
												<div className="leading-normal mt-5 mb-2 text-gray-500 dark:text-white text-left w-10/12 mx-auto">
													<i className="fas fa-map-marker-alt mr-2 text-sm text-gray-600" />
													<label className="text-lg lg:text-xl font-semibold dark:text-white text-gray-600">
														Description:
													</label>
													<Editable
														text={description}
														placeholder="No description is provided"
														childRef={descriptionRef}
														type="textarea"
														className="font-semibold leading-normal w-full p-2"
														textColor="text-gray-700 dark:text-gray-100"
													>
														<textarea
															ref={descriptionRef}
															name="name"
															className="text-gray-700 dark:text-gray-100 font-semibold leading-normal
																	w-full p-2 dark:bg-gray-800"
															placeholder=""
															value={description}
															onChange={(e) => {
																setDescription(e.target.value);
																setIsChanged(true);
															}}
														/>
													</Editable>
												</div>
											</div>
											<div className="mx-auto border-t w-10/12 mt-5 mb-5 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />

											<div>
												<ParentModal
													visible={isStyleModalOpen}
													setModalOpen={setIsStyleModalOpen}
													isChanged={isChanged}
													setIsChanged={setIsChanged}
													isWarnModalOpen={isWarnModalOpen}
													setIsWarnModalOpen={setIsWarnModalOpen}
												>
													<StyleModalContent
														style={style}
														setStyle={setStyle}
														setModalOpen={setIsStyleModalOpen}
														setIsChanged={setIsChanged}
														isChanged={isChanged}
														isWarnModalOpen={isWarnModalOpen}
														setIsWarnModalOpen={setIsWarnModalOpen}
													/>
												</ParentModal>
											</div>

											<div className="flex flex-row justify-center align-middle items-center">
												<button
													type="button"
													className="btn btn-outline btn-sm btn-info mr-2"
													onClick={() => setIsStyleModalOpen(true)}
												>
													Update Style
												</button>

												<div className="relative group px-4 pb-2 mr-4 dark:bg-gray-700 bg-gray-200 rounded-xl">
													<div className="w-full">
														<label className=" text-sm font-medium text-gray-900 dark:text-gray-400">
															{'Set to private'}
														</label>
													</div>
													<div className="mt-0.5 w-full px-4 flex flex-row">
														<Switch
															checked={isPrivate}
															onChange={() => setIsPrivate(!isPrivate)}
															className={`${
																isPrivate ? 'bg-purple-600' : 'bg-gray-600'
															} relative inline-flex h-6 w-11 items-center rounded-full`}
														>
															<span
																className={`${
																	isPrivate ? 'translate-x-6' : 'translate-x-1'
																} inline-block h-4 w-4 transform rounded-full bg-gray-200 transition-all ease-in-out duration-200`}
															/>
														</Switch>
													</div>

													<span
														className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
															scale-0 origin-top group-hover:scale-100 z-50 font-bold transition-all
															duration-500 opacity-0 group-hover:opacity-100 top-14 -right-24"
													>
														{
															"If set to private, the topic won't be shown to anyone"
														}
													</span>
												</div>

												<button
													type="button"
													className="btn btn-outline btn-sm btn-primary mr-1"
													onClick={() => {
														navigator.clipboard.writeText(
															`https://meavana.com/?topic=${code}`
														);

														dispatch(
															SetNotificationAction({
																type: stateNotificationsEnum.SUCCESS,
																message: 'Topic URL copied to clipboard.'
															})
														);
													}}
												>
													generate normal Referral
												</button>

												<div className="w-96 mt-2 px-6">
													{/* <label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">
														Encrypted Referral Code
													</label> */}
													<input
														className="inputStyle"
														id="grid-last-name"
														type="text"
														placeholder="Encrypted Referral Code"
														onChange={(e) => {
															setReferralCode(e.target.value);
														}}
														value={referralCode}
													/>
												</div>

												<button
													type="button"
													className="btn btn-outline btn-sm btn-primary mr-1"
													onClick={() => {
														generateEncryptedReferralCode.mutate();
													}}
												>
													generate Encrypted referral
												</button>
											</div>

											<div className="mx-auto border-t w-10/12 mt-5 mb-4 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />

											<div className="w-10/12 h-12 flex flex-row mb-4 mx-auto">
												<button
													type="button"
													className="relative w-full py-2.5 px-5 mb-2 text-sm font-medium text-gray-900
															 border-gray-200  hover:text-purple-700 dark:text-gray-400
															  dark:border-gray-600 dark:hover:text-white "
													onClick={() => {
														setMediaType(MediaType.IMAGES);
														setPage(1);
													}}
												>
													<div
														className={`absolute inset-0 pb-1 bg-gradient-to-b dark:from-gray-600/50 from-gray-400/50 opacity-0
													hover:opacity-100 transition-all duration-500 text-center
													${mediaType === MediaType.IMAGES && 'opacity-80'}`}
													/>
													Desktop Images
												</button>

												<button
													type="button"
													className="relative w-full py-2.5 px-5 mb-2 text-sm font-medium text-gray-900
												 border-l border-gray-200  hover:text-purple-700 dark:text-gray-400
												dark:border-gray-600 dark:hover:text-white "
													onClick={() => {
														setMediaType(MediaType.PHONE_IMAGES);
														setPage(1);
													}}
												>
													<div
														className={`absolute inset-0 pb-1 bg-gradient-to-b dark:from-gray-600/50 from-gray-400/50 opacity-0
													hover:opacity-100 transition-all duration-500 text-center
													${mediaType === MediaType.PHONE_IMAGES && 'opacity-80'}`}
													/>
													Phone Images
												</button>

												<button
													type="button"
													className="relative w-full py-2.5 px-5 mb-2 text-sm font-medium text-gray-900
												 border-l border-gray-200  hover:text-purple-700 dark:text-gray-400
												dark:border-gray-600 dark:hover:text-white "
													onClick={() => {
														setMediaType(MediaType.VIDEOS);
														setPage(1);
													}}
												>
													<div
														className={`absolute inset-0 pb-1 bg-gradient-to-b dark:from-gray-600/50 from-gray-400/50 opacity-0
													hover:opacity-100 transition-all duration-500 text-center
													${mediaType === MediaType.VIDEOS && 'opacity-80'}`}
													/>
													Videos
												</button>

												<button
													type="button"
													className="relative w-full py-2.5 px-5 mb-2 text-sm font-medium text-gray-900
													border-l border-gray-200  hover:text-purple-700 dark:text-gray-400
												  dark:border-gray-600 dark:hover:text-white "
													onClick={() => {
														setMediaType(MediaType.PHONE_VIDEOS);
														setPage(1);
													}}
												>
													<div
														className={`absolute inset-0 pb-1 bg-gradient-to-b dark:from-gray-600/50 from-gray-400/50 opacity-0
													hover:opacity-100 transition-all duration-500 text-center
													${mediaType === MediaType.PHONE_VIDEOS && 'opacity-80'}`}
													/>
													Phone Videos
												</button>
											</div>

											<div className="container sm:px-2 md:px-20 mx-auto lg:px-32 text-center mb-4">
												<div className="flex flex-row justify-between mb-3">
													<div className="flex flex-1 ">
														<div className="inline-flex">
															<button
																className="btn btn-outline btn-sm btn-primary ml-auto mt-1.5 mr-0"
																onClick={() => {
																	navigate(`reorder-images`);
																}}
															>
																{mediaType === MediaType.IMAGES ||
																mediaType === MediaType.PHONE_IMAGES
																	? 'Edit images layout'
																	: 'Edit videos layout'}
															</button>
														</div>
													</div>
													<h3 className="mt-1 lg:mt-0 xl:flex-1 text-2xl lg:text-4xl font-semibold text-gray-600 dark:text-gray-500">
														{/* IMAGES */}
													</h3>

													<ParentModal
														visible={isAddMultipleImagesModalOpen}
														setModalOpen={setAddMultipleImagesModalOpen}
														isChanged={isAddMultipleImagesModalChanged}
														setIsChanged={setAddMultipleImagesModalChanged}
														isWarnModalOpen={isWarnModalOpen}
														setIsWarnModalOpen={setIsWarnModalOpen}
													>
														<AddMediaModalContent
															setModalOpen={setAddMultipleImagesModalOpen}
															topicId={topicId}
															topicName={name}
															isChanged={isAddMultipleImagesModalChanged}
															setIsChanged={setAddMultipleImagesModalChanged}
															setIsWarnModalOpen={setIsWarnModalOpen}
															media={media}
															setMedia={setMedia}
															mediaCount={mediaCount}
															mediaType={mediaType}
															setMediaCount={setMediaCount}
														/>
													</ParentModal>

													<div className="flex flex-1 justify-end">
														<div className="inline-flex">
															<div className={`relative`}>
																<button
																	className={`relative btn btn-outline btn-sm mt-1.5 mr-0 ml-2 min-w-200 btn-primary`}
																	onClick={() => {
																		setAddMultipleImagesModalOpen(true);
																	}}
																>
																	{mediaType === MediaType.IMAGES ||
																	mediaType === MediaType.PHONE_IMAGES
																		? 'Add Images ➕'
																		: 'Add Videos ➕'}
																</button>
															</div>
														</div>
													</div>
												</div>
												{isFetching || isLoading ? (
													<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 justify-items-center gap-4">
														<LoadingRectanglesAnimation />
													</div>
												) : isError ? (
													<></>
												) : (
													<div className="flex flex-wrap -m-1 md:-m-2">
														{mediaType === MediaType.IMAGES ||
														mediaType === MediaType.PHONE_IMAGES
															? media.map((item: any) => (
																	<BackgroundImage
																		key={item._id}
																		item={item}
																		isMine={true}
																		topicId={topicId}
																		images={media}
																		setImages={setMedia}
																		reloadCount={reloadCount}
																		setReloadCount={setReloadCount}
																		isForPhone={
																			mediaType === MediaType.PHONE_IMAGES
																		}
																		setCoverPic={setCoverPic}
																		extensionImages={extensionMedia}
																		setExtensionImages={setExtensionMedia}
																		setIsChanged={setIsChanged}
																		dailyImageId={dailyImageId}
																	/>
															  ))
															: media.map((item: any) => (
																	<VideoComponent
																		key={item._id}
																		item={item}
																		isMine={true}
																		topicId={topicId}
																		videos={media}
																		setVideos={setMedia}
																		reloadCount={reloadCount}
																		setReloadCount={setReloadCount}
																		isForPhone={
																			mediaType === MediaType.PHONE_VIDEOS
																		}
																		extensionVideos={extensionMedia}
																		setExtensionVideos={setExtensionMedia}
																		setIsChanged={setIsChanged}
																	/>
															  ))}
													</div>
												)}
											</div>
											{isFetching || isLoading || isError ? (
												<></>
											) : media.length > 0 ? (
												<Pagination
													itemsPerPage={data.meta.limit}
													totalCount={data.meta.total}
													totalPages={data.meta.pages}
													currentPage={page}
													setPage={setPage}
												/>
											) : (
												<div>
													<h3 className="dark: text-white font-semibold text-4xl my-32">
														{mediaType === MediaType.IMAGES ||
														mediaType === MediaType.PHONE_IMAGES
															? 'No images were found.'
															: 'No videos were found.'}
													</h3>
												</div>
											)}
										</div>
									</div>
									<div>
										<RemoveModal
											title={'Remove Topic'}
											text={'Are you sure you want to remove this topic?'}
											setModalOpen={setIsRemoveModalOpen}
											setAction={() => deleteTopic()}
											visible={isRemoveModalOpen}
										/>
									</div>
									<div className="w-full px-4">
										<div className="py-6 px-3 flex flex-row">
											<div className="justify-start flex-1">
												<button
													className="btn btn-outline btn-sm btn-error mr-1"
													type="button"
													style={{ transition: 'all .15s ease' }}
													onClick={(e) => {
														e.stopPropagation();
														setIsRemoveModalOpen(true);
													}}
												>
													Delete
												</button>
											</div>
											<div className="justify-end">
												<button
													className="btn btn-outline btn-sm mr-1 "
													type="button"
													style={{ transition: 'all .15s ease' }}
													onClick={() => navigate('../documents')}
												>
													Cancel
												</button>
												{isChanged && (
													<SaveButton
														isSaving={isSaving}
														saveFunc={() => saveTopic.mutate()}
													/>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</main>
				)}
			</Scrollbars>
		</div>
	);
}
